import NexaLight from '../font/Nexa-Light.ttf'
import Nexa from '../font/Nexa-Regular.ttf'
import NexaBold from '../font/Nexa-Bold.ttf'
import NexaExtraBold from '../font/Nexa-ExtraBold.ttf'

const nexaLight = {
  fontFamily: 'Nexa',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 300,
  src: `
    local('Nexa'),
    local('Nexa-Light'),
    url(${NexaLight}) format('truetype')
  `
}

const nexa = {
  fontFamily: 'Nexa',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Nexa'),
    local('Nexa-Regular'),
    url(${Nexa}) format('truetype')
  `
}

const nexaBold = {
  fontFamily: 'Nexa',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `
    local('Nexa'),
    local('Nexa-Bold'),
    url(${NexaBold}) format('truetype')
  `
}

const nexaExtraBold = {
  fontFamily: 'Nexa',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 800,
  src: `
    local('Nexa'),
    local('Nexa-ExtraBold'),
    url(${NexaExtraBold}) format('truetype')
  `
}

const typography = {
  fontFamily: [
    'Nexa',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"'
  ].join(',')
}

const overrides = {
  MuiCssBaseline: {
    '@global': {
      '@font-face': [nexaLight, nexa, nexaBold, nexaExtraBold]
    }
  }
}

export { typography, overrides }
